import axios from "axios";
import { UserInfo } from "../../Models/UserInfo";
import { ApiError } from "../../Models/ApiError";
import { HandleError } from "../../Helpers/ErrorHandler";
import { RefreshTokenRequest } from "../../Models/RefreshTokenRequest";
import { LoginToServerRequest } from "../../Models/LoginToServerRequest";
import { LoginToServerResponse } from "../../Models/LoginToServerResponse";
import { LoginToDatabaseRequest } from "../../Models/LoginToDatabaseRequest";
import { LogoutRequest } from "../../Models/LogoutRequest";

const AUTH_API_URL = process.env.REACT_APP_API_URL;

export const checkIfPasswordNeededToLoginToServerAPI = async (serverUrl: string): Promise<boolean> => {
  return new Promise<boolean>((resolve, reject) => {
    axios
      .get<boolean>(`${AUTH_API_URL}auth/loginserver-check?serverUrl=${encodeURI(serverUrl)}`)
      .then((resp) => {
        if (resp?.data) {
          return resolve(resp?.data || true);
        } else {
          return resolve(true);
        }
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const loginToServerAPI = async (model: LoginToServerRequest): Promise<LoginToServerResponse | null> => {
  return new Promise<LoginToServerResponse | null>((resolve, reject) => {
    axios
      .post<LoginToServerResponse | null>(`${AUTH_API_URL}auth/loginserver`, model)
      .then((resp) => {
        if (resp?.data) {
          return resolve(resp?.data);
        } else {
          return resolve(null);
        }
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const loginToDatabaseAPI = async (model: LoginToDatabaseRequest): Promise<UserInfo | null> => {
  return new Promise<UserInfo | null>((resolve, reject) => {
    axios
      .post<UserInfo | null>(`${AUTH_API_URL}auth/logindb`, model)
      .then((resp) => {
        if (resp?.data) {
          return resolve(resp?.data);
        } else {
          return resolve(null);
        }
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const refreshTokenAPI = async (model: RefreshTokenRequest): Promise<UserInfo | null> => {
  try {
    const resp = await axios.post<UserInfo | null>(`${AUTH_API_URL}auth/refresh`, model);
    return (resp?.data || null) as UserInfo | null;
  } catch (error: any) {
    HandleError(error);
    return null;
  }
};

export const logoutAPI = async (model: LogoutRequest): Promise<string | null> => {
  return new Promise<string | null>((resolve, reject) => {
    axios
      .post<string | null>(`${AUTH_API_URL}auth/logout`, model)
      .then((resp) => {
        if (resp?.data) {
          return resolve(resp?.data);
        } else {
          return resolve(null);
        }
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
